import { useState } from 'react';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import app from '../../../firebase';
import { useAuth } from '../../../core/providers/AuthProvider';
import { useCases } from '../../../core/di/useCases';

// Utiliser getStorage comme dans PhotoStep
const storage = getStorage(app);

export const useProfilePhoto = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadPhoto = async (file) => {
    if (!user?.uid || !file) return null;
    
    try {
      setLoading(true);
      setError(null);
      
      // Définir le chemin de stockage pour les photos de profil
      const storageRef = ref(storage, `users/${user.uid}/profile-photos/${Date.now()}-${file.name}`);
      
      // Upload du fichier
      await uploadBytes(storageRef, file);
      
      // Récupérer l'URL de téléchargement
      const photoURL = await getDownloadURL(storageRef);
      
      // Utiliser le cas d'utilisation approprié pour mettre à jour la photo de profil
      if (useCases.updateUserPhoto) {
        await useCases.updateUserPhoto.execute(user.uid, photoURL);
      } else {
        // Fallback si le cas d'utilisation n'est pas disponible
        await useCases.repositories.users.updateUser(user.uid, { photoURL });
      }
      
      return photoURL;
    } catch (err) {
      console.error('Error uploading photo:', err);
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    uploadPhoto,
    loading,
    error
  };
};
